import React from 'react';
import styled from '@emotion/styled';

import Stacheldraht from '../Stacheldraht';
import ExternalLinksCollection, { ExternalLinksShape } from '../ExternalLinksCollection';

import { showOnlyOnDesktop, minTablet, minDesktop } from '../styles/breakpoints';

const Container = styled.section`
  margin-bottom: 30px;
  ${minTablet} {
    margin-bottom: 50px;
  }
  ${minDesktop} {
    margin-bottom: 0;
  }
`;

const StacheldrahtStyled = styled(Stacheldraht)`
  ${showOnlyOnDesktop};
  position: relative;
  top: 0;
  left: -38%;
`;

const RelatedMaterials = ({ sources }) => (
  <Container>
    <ExternalLinksCollection headline="Weiterführende Materialen" sources={sources} />
    <StacheldrahtStyled small />
  </Container>
);

RelatedMaterials.propTypes = {
  sources: ExternalLinksShape.isRequired,
};


export default RelatedMaterials;



// WEBPACK FOOTER //
// ./src/components/RelatedMaterials/RelatedMaterials.js